module.exports = __webpack_public_path__ + "static/media/pin.04c7b119.svg";